import type { UIMessage } from 'ai'
import type { HavenActionLaunchContext } from './types'

// Only action launches travel as hidden sentinel messages; message-type
// launches are sent as ordinary visible text and must never reach the
// launchContext body field (the API rejects non-action contexts).
interface LaunchSentinelMetadata {
  launchContext: HavenActionLaunchContext
}

const isActionLaunchContext = (
  value: unknown
): value is HavenActionLaunchContext =>
  typeof value === 'object' &&
  value !== null &&
  'type' in value &&
  value.type === 'action'

const hasLaunchMetadata = (
  metadata: unknown
): metadata is LaunchSentinelMetadata =>
  typeof metadata === 'object' &&
  metadata !== null &&
  'launchContext' in metadata &&
  isActionLaunchContext(metadata.launchContext)

export const getLaunchContextFromMessage = (
  msg: UIMessage
): HavenActionLaunchContext | null =>
  hasLaunchMetadata(msg.metadata) ? msg.metadata.launchContext : null

export const isLaunchSentinel = (msg: UIMessage): boolean =>
  getLaunchContextFromMessage(msg) !== null
